import api from "./axiosInterceptor";

export const updateProfilePicture = (postData) =>
  api.put(`accounts/api/user-profile`, postData);
